import { supabase } from './supabase';
import type { SupportAccessAuditAction } from '../types/supportAccess';

export async function insertSupportAccessAudit(params: {
  requestId: string;
  userId: string;
  action: SupportAccessAuditAction;
}): Promise<{ errorMessage: string | null }> {
  const { error } = await supabase.from('support_access_audit').insert({
    request_id: params.requestId,
    user_id: params.userId,
    action: params.action,
  });
  return { errorMessage: error?.message ?? null };
}

const nowIso = (): string => new Date().toISOString();

export async function approveSupportAccessRequest(params: {
  requestId: string;
  userId: string;
}): Promise<{ errorMessage: string | null }> {
  const { error } = await supabase
    .from('support_access_requests')
    .update({
      status: 'active',
      approved_at: nowIso(),
    })
    .eq('id', params.requestId)
    .eq('user_id', params.userId);
  if (error) return { errorMessage: error.message };
  return insertSupportAccessAudit({
    requestId: params.requestId,
    userId: params.userId,
    action: 'access_approved_by_customer',
  });
}

export async function denySupportAccessRequest(params: {
  requestId: string;
  userId: string;
}): Promise<{ errorMessage: string | null }> {
  const { error } = await supabase
    .from('support_access_requests')
    .update({
      status: 'revoked',
      revoked_by: 'customer',
      revoked_at: nowIso(),
    })
    .eq('id', params.requestId)
    .eq('user_id', params.userId);
  if (error) return { errorMessage: error.message };
  return insertSupportAccessAudit({
    requestId: params.requestId,
    userId: params.userId,
    action: 'access_denied_by_customer',
  });
}

export async function revokeSupportAccessRequest(params: {
  requestId: string;
  userId: string;
}): Promise<{ errorMessage: string | null }> {
  const { error } = await supabase
    .from('support_access_requests')
    .update({
      status: 'revoked',
      revoked_at: nowIso(),
      revoked_by: 'customer',
    })
    .eq('id', params.requestId)
    .eq('user_id', params.userId);
  if (error) return { errorMessage: error.message };
  return insertSupportAccessAudit({
    requestId: params.requestId,
    userId: params.userId,
    action: 'access_revoked_by_customer',
  });
}
